// Modules
import React from 'react';
// Material-ui
import { styled } from '@mui/material/styles';
import TableCell, { type TableCellProps } from '@mui/material/TableCell';
import TableRow, { type TableRowProps } from '@mui/material/TableRow';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

export const StyledTableHeaderCell = styled(({ align, children, sx, ...props }: TableCellProps) => (
  <TableCell
    sx={{
      textAlign: align || 'left',
      ...sx,
    }}
    {...props}
  >
    {children}
  </TableCell>
))({
  fontSize: '13px',
  lineHeight: '16px',
  letterSpacing: 'normal',
  color: COLORS.GRAY_SHADE_90,
  fontWeight: 500,
  backgroundColor: COLORS.WHITE,
  borderBottom: `1px solid ${COLORS.BORDER_MAIN}`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '300px',
}) as typeof TableCell;

export const StyledTableBodyCell = styled(TableCell)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '300px',
  position: 'relative',
}) as typeof TableCell;

export const StyledCheckboxHeaderCell = styled(TableCell)({
  padding: '0 10px',
  width: '62px',
  backgroundColor: COLORS.WHITE,
  borderBottom: `1px solid ${COLORS.BORDER_MAIN}`,
}) as typeof TableCell;

export const StyledCheckboxBodyCell = styled(TableCell)({
  padding: '0 10px',
  width: '62px',
}) as typeof TableCell;

export const StyledTableRow: React.ComponentType<
  TableRowProps & { lastVisited?: boolean; hasError?: boolean }
> = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'lastVisited' && prop !== 'hasError',
})<{ lastVisited?: boolean; hasError?: boolean }>(({ lastVisited, theme, hasError }) => ({
  backgroundColor: hasError ? COLORS.ERROR_BG : lastVisited ? COLORS.LIGHT_PURBLE : COLORS.WHITE,
  '&.Mui-selected': {
    backgroundColor: lastVisited ? COLORS.LIGHT_PURBLE : `${theme.mainColorLight} !important`,
  },
  '&:hover': {
    ...(hasError
      ? { boxShadow: 'inset 0 0 0 9999px rgba(255, 255, 255, 0.2)' }
      : {
          backgroundColor: `${theme.mainColorLight} !important`,
          ' input[type="text"]:disabled': {
            backgroundColor: `${theme.mainColorLight} !important`,
          },
        }),
  },
}));

export const StyledTableDialogRow = styled(TableRow)(({ theme }) => ({
  '&.Mui-selected': {
    backgroundColor: `${theme.mainColorLight} !important`,
  },
  '&:hover': {
    backgroundColor: `${theme.mainColorLight} !important`,
  },
  '& > td:first-of-type': {
    paddingLeft: '2rem',
  },
  '& > th:first-of-type': {
    paddingLeft: '2rem',
  },
  '& > td:last-of-type': {
    paddingRight: '2rem',
  },
  '& > th:last-of-type': {
    paddingRight: '2rem',
  },
})) as typeof TableRow;
